// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bic_wx bic_jb bic_xl bic_i bic_j bic_q bic_vt bic_et bic_so bic_sp bic_eg","CommentsButton__icon":"il_b bic_rz"};